module.exports = __webpack_public_path__ + "img/addmail.7caccc04.svg";